import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconCompassPointer"><Path d="M10.3713 3.08351C11.0176 1.70133 12.9828 1.70133 13.6291 3.08351L20.8273 18.4761C21.534 19.9889 19.9763 21.5647 18.4552 20.8755L12.0832 17.9868C12.0304 17.963 11.9699 17.963 11.9172 17.9868L5.54509 20.8755C4.02395 21.5651 2.46616 19.9891 3.17302 18.4761L10.3713 3.08351Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointer;
